import { Injectable } from '@angular/core';
import { Alert } from '@approot/models';
import { ActiveToast, ToastrService } from 'ngx-toastr';
import { PhoenixEventBusService } from '../phoenix/phoenix-event-bus.service';
import { UserStorageService } from '../user-storage/user-storage.service';
import { HttpErrorResponse } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class AlertsService {
  constructor(
    private toastr: ToastrService,
    private userStorageService: UserStorageService,
    private phxEventBus: PhoenixEventBusService
  ) {}

  public addAlert(alert: Alert): ActiveToast<any> {
    if (alert == null) {
      alert = { message: null, id: null };
    }

    let defaultMessage = alert.urlPath
      ? `An unnown error was encountered when calling ${alert.urlPath}`
      : `An unknown error was encountered`;
    // alert.errorMessage shouldn't actually be there - need to find out why it is there
    // and remove in due course.  In the meantime it's deliberately untyped.
    let message = alert.message || alert['errorMessage'] || defaultMessage;
    if (typeof message !== 'string') {
      try {
        message = JSON.stringify(message);
      } catch {}
    }
    alert.config = alert.config ?? {};
    alert.config = {
      tapToDismiss: false,
      closeButton: true,
      ...alert.config
    };

    alert.config.enableHtml = true;
    alert.message = message;
    if (alert.message.length > 200) {
      alert.message = alert.message.substring(0, 200) + '&hellip;';
    }
    if (alert.id) {
      alert.message = `<div>${alert.message}</div>`;
      alert.message += `<div>If the problem persists, please contact support quoting ${alert.id}</div>`;
    }

    delete alert['errorMessage'];

    if (!!alert.ping) {
      this.userStorageService.ping();
    }

    switch (alert.type) {
      case 'success':
      case 'info':
        return this.toastr.success(alert.message, alert.title, alert.config);
      case 'warning':
      case 'warn':
        return this.toastr.warning(alert.message, alert.title, alert.config);
      default:
        if (!alert.skipLog) {
          this.phxEventBus.addEvent({
            type: 'ui',
            level: 'error',
            category: 'error',
            message,
            errorId: alert.id,
            payload: alert.payload,
            error: alert.error
          });
        }
        return this.toastr.error(alert.message, alert.title, alert.config);
    }
  }

  public addHttpAlert(alert: Alert) {
    const error = alert.error as HttpErrorResponse;
    const message = alert.message;

    if (error.error instanceof ErrorEvent) {
      console.error('An error occurred:', error.error.message);
    } else {
      if (error.error.isTrusted === true) {
        const url = error.url ? ` while calling ${error.url}` : '';
        this.addAlert({
          message:
            message || `A HTTP error occurred${url}. Please try again later.`,
          urlPath: url,
          error
        });
      } else {
        this.addAlert({
          message:
            message ||
            error.error?.message ||
            error.message ||
            error.error ||
            error,
          urlPath: error.url,
          error
        });
      }
      console.error(
        `Backend returned code ${error.status}, ` + `body was: ${error.error}`
      );
    }
  }
}
